import { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorCode } from './Error';
import { mapError } from './mapError';
import ValidationResult from './ValidationResult';

export default class ErrorResponse extends ApiClientErrorResponse {
	handleCalculationRequiresAtLeastOneReferenceCountryProduct(): boolean {
		return this.handle(ErrorCode.RequiresAtLeastOneReferenceCountryProduct);
	}

	handleCalculationRequiresAtLeastOneProduct(): boolean {
		return this.handle(ErrorCode.RequiresAtLeastOneProduct);
	}

	handleCalculationRequiresAtMostOneProductForEachCountry(): boolean {
		return this.handle(ErrorCode.OnlyOneProductPerCountryErrorCode);
	}

	handleCalculationRequiresReferenceSettings(): boolean {
		return this.handle(ErrorCode.RequiresReferenceSettingsErrorCode);
	}

	handleCalculationRequiredProductSettingsIsMissing(): boolean {
		return this.handle(ErrorCode.RequiredProductSettingsMissingErrorCode);
	}

	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleCannotChangeSettingsForNonMemberProducts(): boolean {
		return this.handle(ErrorCode.CannotChangeSettingsForNonMemberProducts);
	}

	handleCannotChangeSettingsForNonMemberProductLists(): boolean {
		return this.handle(ErrorCode.CannotChangeSettingsForNonMemberProductLists);
	}

	handleIllegalPriceTypeSelected(): boolean {
		return this.handle(ErrorCode.IllegalPriceTypeSelectedErrorCode);
	}

	handleCalculationRequiresAtLeastOneProductList(): boolean {
		return this.handle(ErrorCode.RequiresAtLeastOneProductList);
	}

	handleSettingsUnknownSavingsGroups(): boolean {
		return this.handle(ErrorCode.SettingsUnknownSavingsGroups);
	}

	findUnknownSavingsGroups(): string[] {
		const error = this.errors.find((candidate) => candidate.code === ErrorCode.SettingsUnknownSavingsGroups);
		return (error?.meta.unknownGroups ?? []) as string[];
	}

	toValidationResult(): ValidationResult {
		const errors = this.errors.map(mapError);

		return new ValidationResult(
			errors.find((error) => error.productGroupId !== null)?.productGroupId ?? null,
			errors.find((error) => error.code === ErrorCode.RequiresReferenceSettingsErrorCode) !== undefined,
			errors.filter((error) => error.productId !== null),
			errors.filter((error) => error.duplicateCountries.length > 0)
		);
	}
}
